import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MoreHorizontal } from 'lucide-react';
import MoreSheet from './MoreSheet.jsx';
import { useNavItems } from '../hooks/useNavItems.js';
import { MOBILE_TAB_PATHS, isNavItemActive } from '../lib/navItems.js';

const TAB_CLASS = 'flex-1 flex flex-col items-center justify-center gap-0.5 min-h-14 py-1.5 text-[11px] font-medium transition-colors';

function tabColor(isActive) {
  return isActive ? 'text-slate-900' : 'text-slate-400 hover:text-slate-600';
}

export default function BottomTabBar() {
  const { pathname } = useLocation();
  const items = useNavItems();
  const [moreOpen, setMoreOpen] = useState(false);

  useEffect(() => { setMoreOpen(false); }, [pathname]);

  const tabs = MOBILE_TAB_PATHS.map((to) => items.find((i) => i.to === to)).filter(Boolean);
  const moreItems = items.filter((i) => !MOBILE_TAB_PATHS.includes(i.to));
  const moreActive = moreItems.some((i) => isNavItemActive(i, pathname));

  return (
    <>
      <MoreSheet open={moreOpen} onClose={() => setMoreOpen(false)} items={moreItems} />
      <nav
        className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 flex lg:hidden"
        style={{
          paddingBottom: 'env(safe-area-inset-bottom)',
          paddingLeft: 'env(safe-area-inset-left)',
          paddingRight: 'env(safe-area-inset-right)',
        }}
        aria-label="Navigation principale"
      >
        {tabs.map((item) => {
          const { to, label, Icon, exact } = item;
          const isActive = isNavItemActive(item, pathname);
          return (
            <NavLink key={to} to={to} end={exact} className={`${TAB_CLASS} ${tabColor(isActive)}`} aria-label={label}>
              <Icon size={22} strokeWidth={isActive ? 2.5 : 1.75} aria-hidden />
              <span>{label}</span>
            </NavLink>
          );
        })}
        <button
          type="button"
          onClick={() => setMoreOpen((o) => !o)}
          className={`${TAB_CLASS} ${tabColor(moreActive || moreOpen)}`}
          aria-label="Plus"
          aria-expanded={moreOpen}
        >
          <MoreHorizontal size={22} strokeWidth={moreActive || moreOpen ? 2.5 : 1.75} aria-hidden />
          <span>Plus</span>
        </button>
      </nav>
    </>
  );
}
